import {
    defineComponent,
    ref,
    computed,
    watch
} from "vue";

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlSearchActiveOrganisations',
    setup(props, ctx) {
        const onlySearchActiveOrganisations = ref<boolean>(true);

        const watchFields = computed(() => {
            return [onlySearchActiveOrganisations.value];
        });

        const onFieldChange = () => {
            search();
        };

        const search = () => {
            ctx.emit("search", onlySearchActiveOrganisations.value);
        };

        watch(watchFields, onFieldChange, {immediate: false, deep: true});

        return {
            onlySearchActiveOrganisations,
            onFieldChange,
            search,
        };
    },
});
